import { withArraySelector } from './array-selector';
export * from './array-selector';
import { withDefaultShallow } from './default-shallow';
export * from './default-shallow';
export * from './types';

// src/index.ts
var withZustandards = (storeHook) => withArraySelector(withDefaultShallow(storeHook));

export { withZustandards };
